/**
 * Canonical invoice Doc Type options (create wizard + classic form).
 * Values are persisted as `document_type` / `formData.documentType` and shown
 * as the preview document title.
 */

export const INVOICE_DOCUMENT_TYPE = {
  TAX_INVOICE: 'Tax Invoice',
  PROFORMA: 'Proforma Invoice',
  CREDIT_NOTE: 'Credit Note',
  DEBIT_NOTE: 'Debit Note',
}

/** Bootstrap-Vue radio-button group options (`text` / `value`). */
export const INVOICE_DOCUMENT_TYPE_OPTIONS = [
  { text: 'Tax Invoice', value: INVOICE_DOCUMENT_TYPE.TAX_INVOICE },
  { text: 'Proforma', value: INVOICE_DOCUMENT_TYPE.PROFORMA },
  { text: 'Credit Note', value: INVOICE_DOCUMENT_TYPE.CREDIT_NOTE },
  { text: 'Debit Note', value: INVOICE_DOCUMENT_TYPE.DEBIT_NOTE },
]

/** v-select style options (`title` / `value`) for CreateInvoice. */
export const INVOICE_DOCUMENT_TYPE_SELECT_OPTIONS = [
  { title: 'Tax Invoice', value: INVOICE_DOCUMENT_TYPE.TAX_INVOICE },
  { title: 'Proforma Invoice', value: INVOICE_DOCUMENT_TYPE.PROFORMA },
  { title: 'Credit Note', value: INVOICE_DOCUMENT_TYPE.CREDIT_NOTE },
  { title: 'Debit Note', value: INVOICE_DOCUMENT_TYPE.DEBIT_NOTE },
]

/**
 * Short label used in auto invoice name / download filename:
 * `{Client} {Invoice|Proforma|Credit Note|Debit Note} {Id} ({Mon-YYYY})`
 */
export function documentTypeToFilenameLabel(documentType) {
  const docType = String(documentType || '')
  if (/proforma|perfoma/i.test(docType)) return 'Proforma'
  if (/credit\s*note/i.test(docType)) return 'Credit Note'
  if (/debit\s*note/i.test(docType)) return 'Debit Note'
  return 'Invoice'
}
